import React, { ChangeEvent, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { newUser } from "../../services/UserService";
import { Form } from "react-bootstrap";
import { cpf, cnpj } from 'cpf-cnpj-validator';
import Alert from '../../helpers/Alert';
import Input from "../../components/Form/Input";
import Select from "../../components/Form/Select";
import useWindowDimensions from "../../helpers/GetCurrentWidth";
import PublicBackground from "../../components/PublicBackground";
import Mail from "../../assets/images/mail.svg";

import "./index.css";
import "./mail.css";

interface TypeData {
  name: string;
  email: string;
  cpf_cnpj: string;
  branch: string;
  password: string;
  passwordConfirm: string; // Novo campo para a senha confirmada
  terms: boolean;
}

export default function SignupPage() {
  let history = useNavigate();

  const [data, setData] = useState<TypeData>({
    name: "",
    email: "",
    cpf_cnpj: "",
    branch: "Sindicancia",
    password: "",
    passwordConfirm: "",
    terms: false,
  });
  const [showConfirmation, setShowConfirmation] = useState(false);

  const { width } = useWindowDimensions();

  const handleCheck = () => {
    setData({ ...data, terms: !data.terms });
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setData({ ...data, [name]: value });
  };

  const handleSelectChange = (name: string, value: any) => {
    setData({ ...data, [name]: value });
  };

  const handleSubmit = (event: ChangeEvent<HTMLFormElement>) => {
    event.preventDefault();
    const isValid = validation();
    if (isValid) {
      insertUser();
    }
  };

  const validation = () => {
    const { password, passwordConfirm, terms } = data;

    if (password.length < 6) {
      Alert(false, "Senha precisa ter 6 ou mais caracteres");
      return false;
    } else if (password !== passwordConfirm) {
      Alert(false, "As senhas não coincidem");
      return false;
    } else if (!terms) {
      Alert(false, "Confirme os termos de uso");
      return false;
    }

    return true;
  };

  const insertUser = () => {
    const { name, email, password } = data;
    newUser({ name, email, password })
      .then((res) => {
        setShowConfirmation(true);
      })
      .catch((err) => {
        /*
         * O backend já explica o que houve — "Cadastro do e-mail já existe.",
         * "não foi possível enviar o e-mail de confirmação" — mas a tela
         * descartava tudo e mostrava sempre a mesma frase genérica. Quem já
         * tinha conta ficava sem saber que bastava entrar.
         */
        const resposta = err?.response?.data;
        const mensagem =
          resposta?.error ||
          resposta?.message ||
          (Array.isArray(resposta?.errors) && resposta.errors[0]?.message) ||
          (err?.response?.status === 409 ? "Cadastro do e-mail já existe." : "") ||
          "Não foi possível realizar o cadastro. Tente novamente em alguns minutos.";
        Alert(false, mensagem);
      });
  };

  return (
    <PublicBackground>
      {showConfirmation ? (
        <div className="mail--content-wrapper">
          <img className="mail--image-content" src={Mail} alt="" />
          <div className="mail--content-container">
            <div className="mail--content-description">
              Você receberá um email para a ativação do cadastro.
            </div>

            <button
              onClick={() => history("/login")} // Corrigido para usar history corretamente
              className="mail--button"
            >
              Voltar para o login
            </button>
          </div>
        </div>
      ) : (
          <>
            <div className="signup-title">Crie Sua conta</div>
            <div className="signup--form-container">
              <Form onSubmit={handleSubmit} className="signup-form">
                <Input
                  className="signup-input"
                  name="name"
                  label="Nome"
                  type="text"
                  placeholder="Digite seu nome"
                  data={data.name}
                  setData={handleInputChange}
                  required
                />
                <Input
                  name="cpf_cnpj"
                  label="CPF ou CNPJ"
                  type="text"
                  placeholder="Digite seu CPF ou CNPJ"
                  data={data.cpf_cnpj}
                  setData={handleInputChange}
                  className={(cpf.isValid(data.cpf_cnpj) || cnpj.isValid(data.cpf_cnpj)) ? 'signup-input inputSuccess' : 'signup-input inputError'}
                  required />
                <Input
                  className="signup-input"
                  name="email"
                  label="E-mail"
                  type="email"
                  placeholder="email@email.com"
                  data={data.email}
                  setData={handleInputChange}
                  required
                />
                <Input
                  className="signup-input"
                  name="password"
                  label="Senha"
                  type="password"
                  placeholder="Digite sua senha"
                  data={data.password}
                  setData={handleInputChange}
                  required
                />
                <Input
                  className="signup-input"
                  name="passwordConfirm"
                  label="Confirmar Senha"
                  type="password"
                  placeholder="Confirme sua senha"
                  data={data.passwordConfirm}
                  setData={handleInputChange}
                  required
                />
                {(data.password.length > 0 && data.password.length < 6) && (
                  <Form.Text className="text-muted">A senha deve ter pelo menos 6 caracteres.</Form.Text>
                )}
                {(data.passwordConfirm.length > 0 && data.password != data.passwordConfirm) && (
                  <Form.Text className="text-muted">As senhas não coincidem</Form.Text>
                )}
                <div className="form-group mt-3">
                  <div className="field">
                    <label className='checkbox'>
                      <input
                        type='checkbox'
                        name='termsCheckbox'
                        checked={data.terms || false}
                        onClick={({ target }: any) => { handleCheck() }}
                      /><span>Eu li e concordo com os <a href="/termos" target="_blank">termos de uso</a></span>
                    </label>
                  </div>
                </div>
                <button className="signup-button" type="submit">
                  Cadastrar
              </button>
                <div className="signup-signup--wrapper">
                  <NavLink to="/login">
                    <span className="signup-signup">Já tenho acesso</span>
                  </NavLink>
                </div>
              </Form>
            </div>
          </>
        )
      }
    </PublicBackground >
  );
}
